(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["WISHLIST_HERO_BKP_header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  if (!window.megaMenuDrawerInit) {
    window.megaMenuDrawerInit = true;

    function closeMegaDrawer(drawer) {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.querySelectorAll('.mega-menu-drawer__panel.is-active').forEach(function (panel) {
        panel.classList.remove('is-active');
      });
      document.querySelectorAll('[data-mega-drawer-target="' + drawer.id + '"][aria-expanded="true"]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
      document.body.classList.remove('mega-menu-drawer-open');
    }

    function activateMegaPanel(panel) {
      if (!panel || !panel.parentElement) return;
      var siblings = panel.parentElement.querySelectorAll(':scope > .mega-menu-drawer__panel');
      siblings.forEach(function (el) {
        el.classList.remove('is-active');
      });
      panel.classList.add('is-active');
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-mega-drawer-trigger]');
      if (trigger) {
        event.preventDefault();
        var drawer = document.getElementById(trigger.getAttribute('data-mega-drawer-target'));
        if (!drawer) return;

        document.querySelectorAll('.mega-menu-drawer.is-open').forEach(function (openDrawer) {
          if (openDrawer !== drawer) closeMegaDrawer(openDrawer);
        });

        drawer.querySelectorAll('.mega-menu-drawer__panel.is-active').forEach(function (panel) {
          panel.classList.remove('is-active');
        });

        var panel = document.getElementById(trigger.getAttribute('data-mega-drawer-trigger'));
        activateMegaPanel(panel);

        drawer.classList.add('is-open');
        document.body.classList.add('mega-menu-drawer-open');
        document.querySelectorAll('[data-mega-drawer-target="' + drawer.id + '"]').forEach(function (btn) {
          btn.setAttribute('aria-expanded', btn === trigger ? 'true' : 'false');
        });
        drawer.dataset.returnFocusId = trigger.id || '';
        return;
      }

      var openTarget = event.target.closest('[data-mega-drawer-open]');
      if (openTarget) {
        event.preventDefault();
        activateMegaPanel(document.getElementById(openTarget.getAttribute('data-mega-drawer-open')));
        return;
      }

      var backTarget = event.target.closest('[data-mega-drawer-back]');
      if (backTarget) {
        event.preventDefault();
        var panelToClose = backTarget.closest('.mega-menu-drawer__panel');
        if (panelToClose) panelToClose.classList.remove('is-active');
        return;
      }

      var closeTarget = event.target.closest('[data-mega-drawer-close]');
      if (closeTarget) {
        event.preventDefault();
        var openDrawer = closeTarget.closest('.mega-menu-drawer');
        if (!openDrawer) return;
        var returnId = openDrawer.dataset.returnFocusId;
        closeMegaDrawer(openDrawer);
        if (returnId) {
          var returnEl = document.getElementById(returnId);
          if (returnEl) returnEl.focus();
        }
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var openDrawer = document.querySelector('.mega-menu-drawer.is-open');
      if (openDrawer) closeMegaDrawer(openDrawer);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dma-elevated-unboxing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function splitWords(el) {
      if (el.getAttribute('data-dmu-words') === 'done') return;

      var step = parseInt(el.getAttribute('data-dmu-word-stagger') || '55', 10);
      var words = el.textContent.trim().split(/\s+/);

      el.setAttribute('data-dmu-words', 'done');
      el.textContent = '';

      words.forEach(function (word, i) {
        var mask = document.createElement('span');
        mask.className = 'dmu__w';

        var inner = document.createElement('span');
        inner.className = 'dmu__wi';
        inner.textContent = word;
        inner.style.setProperty('--dmu-wd', (i * step) + 'ms');

        mask.appendChild(inner);
        el.appendChild(mask);

        if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
      });
    }

    function setup(root) {
      if (root.dataset.dmuReady === 'true') return;
      root.dataset.dmuReady = 'true';

      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduced || !('IntersectionObserver' in window)) {
        root.classList.remove('dmu--anim');
        root.classList.add('is-in');
        return;
      }

      root.classList.add('dmu--anim');

      var heading = root.querySelector('[data-dmu-words]');
      if (heading) splitWords(heading);

      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          obs.unobserve(entry.target);
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' });

      io.observe(root);
    }

    function init(scope) {
      var ctx = scope || document;
      Array.prototype.forEach.call(ctx.querySelectorAll('.dmu'), setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dma-hj-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function headerHeight() {
      var wrap = document.querySelector('.header-wrapper');
      return wrap ? wrap.getBoundingClientRect().height : 0;
    }

    function resolveTarget(hero) {
      var selector = hero.dataset.dmhTarget;

      if (selector) {
        var picked = document.querySelector(selector);
        if (picked) return picked;
      }

      var wrapper = hero.closest('.shopify-section') || hero.parentElement;
      return wrapper ? wrapper.nextElementSibling : null;
    }

    function setup(hero) {
      if (hero.dataset.dmhReady === 'true') return;
      hero.dataset.dmhReady = 'true';

      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var cue = hero.querySelector('[data-dmh-cue]');

      if (cue) {
        cue.addEventListener('click', function () {
          var target = resolveTarget(hero);
          if (!target) return;

          var top = window.scrollY + target.getBoundingClientRect().top;

          window.scrollTo({
            top: Math.max(0, Math.round(top)),
            behavior: reduced ? 'auto' : 'smooth'
          });
        });
      }

      var wantsDesktop = hero.dataset.dmhOverlayHeader === 'true';
      var wantsMobile = hero.dataset.dmhOverlayHeaderMobile === 'true';

      if (!wantsDesktop && !wantsMobile) {
        document.body.classList.remove('dmh-header-over');
        return;
      }

      var ticking = false;

      function apply() {
        ticking = false;

        var mobile = window.matchMedia('(max-width: 749px)').matches;

        if (mobile ? !wantsMobile : !wantsDesktop) {
          document.body.classList.remove('dmh-header-over');
          return;
        }

        var height = hero.offsetHeight;

        if (!height) {
          document.body.classList.add('dmh-header-over');
          return;
        }

        var handover = height - headerHeight();
        var over = handover > 0 && window.scrollY < handover;

        document.body.classList.toggle('dmh-header-over', over);
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(apply);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);

      window.addEventListener('load', apply);

      var img = hero.querySelector('.dmh-hero__img');
      if (img && !img.complete) img.addEventListener('load', apply, { once: true });

      apply();
    }

    function init(scope) {
      var ctx = scope || document;
      Array.prototype.forEach.call(ctx.querySelectorAll('[data-dmh-hero]'), setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (e) { init(e.target); });

    document.addEventListener('shopify:section:unload', function (e) {
      if (e.target.querySelector('[data-dmh-hero]')) {
        document.body.classList.remove('dmh-header-over');
      }
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dma-hj-intro"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      if (root.dataset.dmhIntroReady === 'true') return;
      root.dataset.dmhIntroReady = 'true';

      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduced || !('IntersectionObserver' in window)) {
        root.classList.remove('dmh-intro--anim');
        root.classList.add('is-in');
        return;
      }

      root.classList.add('dmh-intro--anim');

      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          obs.unobserve(entry.target);
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' });

      io.observe(root);
    }

    function init(scope) {
      var ctx = scope || document;
      Array.prototype.forEach.call(ctx.querySelectorAll('[data-dmh-intro]'), setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  if (!window.megaMenuDrawerInit) {
    window.megaMenuDrawerInit = true;

    function closeMegaDrawer(drawer) {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.querySelectorAll('.mega-menu-drawer__panel.is-active').forEach(function (panel) {
        panel.classList.remove('is-active');
      });
      document.querySelectorAll('[data-mega-drawer-target="' + drawer.id + '"][aria-expanded="true"]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
      document.body.classList.remove('mega-menu-drawer-open');
    }

    function activateMegaPanel(panel) {
      if (!panel || !panel.parentElement) return;
      var siblings = panel.parentElement.querySelectorAll(':scope > .mega-menu-drawer__panel');
      siblings.forEach(function (el) {
        el.classList.remove('is-active');
      });
      panel.classList.add('is-active');
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-mega-drawer-trigger]');
      if (trigger) {
        event.preventDefault();
        var drawer = document.getElementById(trigger.getAttribute('data-mega-drawer-target'));
        if (!drawer) return;

        document.querySelectorAll('.mega-menu-drawer.is-open').forEach(function (openDrawer) {
          if (openDrawer !== drawer) closeMegaDrawer(openDrawer);
        });

        drawer.querySelectorAll('.mega-menu-drawer__panel.is-active').forEach(function (panel) {
          panel.classList.remove('is-active');
        });

        var panel = document.getElementById(trigger.getAttribute('data-mega-drawer-trigger'));
        activateMegaPanel(panel);

        drawer.classList.add('is-open');
        document.body.classList.add('mega-menu-drawer-open');
        document.querySelectorAll('[data-mega-drawer-target="' + drawer.id + '"]').forEach(function (btn) {
          btn.setAttribute('aria-expanded', btn === trigger ? 'true' : 'false');
        });
        drawer.dataset.returnFocusId = trigger.id || '';
        return;
      }

      var openTarget = event.target.closest('[data-mega-drawer-open]');
      if (openTarget) {
        event.preventDefault();
        activateMegaPanel(document.getElementById(openTarget.getAttribute('data-mega-drawer-open')));
        return;
      }

      var backTarget = event.target.closest('[data-mega-drawer-back]');
      if (backTarget) {
        event.preventDefault();
        var panelToClose = backTarget.closest('.mega-menu-drawer__panel');
        if (panelToClose) panelToClose.classList.remove('is-active');
        return;
      }

      var closeTarget = event.target.closest('[data-mega-drawer-close]');
      if (closeTarget) {
        event.preventDefault();
        var openDrawer = closeTarget.closest('.mega-menu-drawer');
        if (!openDrawer) return;
        var returnId = openDrawer.dataset.returnFocusId;
        closeMegaDrawer(openDrawer);
        if (returnId) {
          var returnEl = document.getElementById(returnId);
          if (returnEl) returnEl.focus();
        }
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var openDrawer = document.querySelector('.mega-menu-drawer.is-open');
      if (openDrawer) closeMegaDrawer(openDrawer);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
